import {ProDirectoryPage, ProDirectoryPageContent} from '../types/pro-directory-page.types'
import {ProDirectoryPageFieldsFragment} from '../../../../__generated__/datocms.types'
import {validateDatoCmsTypes} from './common.serde'
import {parseReviewSection} from './review-section.serde'
import {parseKnowledgeSection} from './knowledge-section.serde'
import {parsePromotionalBannerSection} from './promotional-banner-section.serde'
import {parseInspirationSection} from './inspiration-section.serde'
import {parseSignupSection} from './signup-section.serde'

export function parseProDirectoryPage(e: ProDirectoryPageFieldsFragment): ProDirectoryPage {
  const entry = validateDatoCmsTypes(e)
  const page = validateDatoCmsTypes(entry)
  const content: ProDirectoryPageContent[] = page.content
    ?.map((c): ProDirectoryPageContent | undefined => {
      switch (c?.__typename) {
        case 'ReviewSectionModelRecord':
          return parseReviewSection(c)
        case 'KnowledgeSectionModelRecord':
          return parseKnowledgeSection(c)
        case 'PromotionBannerModelRecord':
          return parsePromotionalBannerSection(c)
        case 'InspirationSectionModelRecord':
          return parseInspirationSection(c)
        case 'FieldSignupSectionRecord':
          return parseSignupSection(c)
        default: {
          return undefined
        }
      }
    })
    .filter((c): c is ProDirectoryPageContent => !!c)

  return {
    content: content || [],
  }
}
